import { Box, styled } from '@mui/material';

export const FormSection = styled(Box)(({ theme }) => ({
  backgroundColor: 'white',
  border: `1px solid ${theme.palette.other.outlineBorder}`,
  borderRadius: '2px',
  padding: theme.spacing(3),
}));
